import { Component } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { LocationService } from '../location.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DomSanitizer } from '@angular/platform-browser';
import * as htmlToImage from 'html-to-image';
let k = 1;
@Component({
  selector: 'app-create-subscription',
  templateUrl: './create-subscription.component.html',
  styleUrls: ['./create-subscription.component.scss'],
})
export class CreateSubscriptionComponent {
  list: any = [
    { name: 'General', style: 'none', id: 0 },
    { name: 'Services', style: 'none', id: 1 },
    { name: 'Pricing', style: 'none', id: 2 }, 
    { name: 'Image', style: 'none', id: 3 },
    {name: 'Service Details', style: 'none', id: 4},
    
  ];
  htmlContent;
  blob; check:boolean; src;
  description;  
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    showToolbar: true,
    height: '10rem',
    minHeight: '10rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  activeInd: boolean = true;
  loader:boolean = true;
  change:boolean;
  markedPrice;
  price;
  stockOutQty;
  itemCategoryObj;
  actDuration;
  categorysearchtypes:any= [];
  serviceId;
  pic;
  item:any;
  duration;
  typeObj;
  typeName;
  typeId;
  id;
  promotions: any = []; promoId; promotionName = 'Select';
  category: any = [];
  name;
  itemsub;
  subsStartTime;
  subsEndTime;
  coupon;
  PackageInclude:any;
  Id;
  cateName;
  itemCategory;
  itemCategoryId;
  itemCateId;
  itemCateName;
  cateId;
  type;
  editBool:boolean;
  pageOne:boolean;
  pageTwo:boolean;
  users:any=[];Name;UserId;orgId;
  discountCoupon;
  assign:boolean;
  payTotal;
  pay;
  recurrence;
  recurrenceName;
  recurrenceId;
  org;
  orgDetail:any=[];
  allServices:any=[];
  taxIncluded:boolean;
  pacService:any=[];
  services:any=[];
  addNew:boolean=true;
  clone: any = [];
  serviceName;
  region;
  discount;
  discountObj;
  discountId;
  defcost;
  discountName;
  applicableDays;
  applicableDaysName;
  applicableDaysId;
  billingPeriod;
  billingPeriodName;
  billingPeriodId;
  daysObj=[{id:1,name:"Sunday"},
  {id:2,name:"Monday"},
  {id:3,name:"Tuesday"},
  {id:4,name:"Wednesday"},
  {id:5,name:"Thursday"},
  {id:6,name:"Friday"},
  {id:7,name:"Saturday"},
]
  daySearch;
  thumbnail;
  videoName;
  provicerServiceId;
  videoId;
  videoChange:boolean;
  // serviceDetails:any=[];
  url1;
  blob1;
  imageName;
  updateImage:boolean=false;
  thumbnail1:any;

  constructor( protected sanitizer: DomSanitizer,private router: Router, private bottomSheet: MatBottomSheet,  public handler: HandlerService, private platform: Platform,
    public service: ApiService, private http:HttpClient,public location: LocationService) { }

    ionViewWillEnter(){
     this.list[0].style='active';
     let url = window.location.href;
     this.url1 = window.location.href
     localStorage.setItem('currentUserId','23874')
     sessionStorage.setItem('vendorApp','true');
     this.id = localStorage.getItem('organizationId')
     this.pageOne = true;
     this.pageTwo = false;
     this.getRecurrence();
     this.getCategory();
     this.getSingleService();
     this.getDiscount();
      this.vendoruser();
      this.getOrg();
      this.getBilling();
      this.getdays();
      // this.itemType();
        if (url.includes('edit-subs')) {
          this.editBool = true;
          this.id = window.location.href.split('/').pop();
          this.service.getSubscriptionById(this.id).subscribe((res: any) => {
            this.itemsub = res;
            this.name = res.name;
            this.activeInd = res.activeInd;   
            this.PackageInclude=res.packageIncludes;
            this.pic=res.img;
            this.defcost = res.dfltCost;
            this.discount = res.discAdId;
            this.itemCateId = res.itemTypeId;
            this.taxIncluded= res.taxIncluded;
            this.recurrenceId = res.recurrenceId;
            this.billingPeriodId = res.billingPeriod;
            this.applicableDaysId=res.applicableDays;
            this.cateId=res.itemCategoryId;       
            this.pacService = res.subCost;
            this.htmlContent=res.description;
            this.services = res.packServices;
            this.videoId = res.docId;
            this.videoChange = false;
            if(res.imageId){
              this.getImageIcon(res.imageId)
            }
            if(res.docId){
              this.getVideIcon(res.docId)
            }
            this.services.map(res=>{
              if(res.autoGenerate){
                Object.assign(res,{autoGenerate:true})
              }else{
                Object.assign(res,{autoGenerate:false})
              }
            })
            this.services.map(res=>{
             if(res.applicableSunday){
              Object.assign(res,{sunday:true})
             }else{
              Object.assign(res,{sunday:false})
             }

             if(res.applicableMonday){
              Object.assign(res,{monday:true})
             }else{
              Object.assign(res,{monday:false})
             }

             if(res.applicableTuesday){
              Object.assign(res,{tuesday:true})
             }else{
              Object.assign(res,{tuesday:false})
             }

             if(res.applicableWednesday){
              Object.assign(res,{wednesday:true})
             }else{
              Object.assign(res,{wednesday:false})
             }

             if(res.applicableThursday){
              Object.assign(res,{thursday:true})
             }else{
              Object.assign(res,{thursday:false})
             }

             if(res.applicableFriday){
              Object.assign(res,{friday:true})
             }else{
              Object.assign(res,{friday:false})
             }

             if(res.applicableSaturday){
              Object.assign(res,{saturday:true})
             }else{
              Object.assign(res,{saturday:false})
             }
            })
           
            setTimeout(() => {
              if (this.discountObj.length > 0) {
                this.discountObj.map(res1 => {
                  if (res1.id ==  this.discount ) {
                    this.discountName = res1.name;
                    this.discountId = res1.id;
                  }
                })
              } 
            }, 1200);
            setTimeout(() => {
              this.category.map(res1 => {
                if (res1.id == this.cateId) {
                  this.cateName = res1.name;
                  this.cateId = res1.id;
                }
              })
            }, 1000);
            // setTimeout(() => {
            //   this.itemCategory.map(res1 => {
            //     if (res1.id == this.itemCateId) {
            //       this.itemCateName = res1.name;
            //       this.itemCateId = res1.id;
            //     }
            //   })
            //  }, 1000);
             setTimeout(() => {
              this.billingPeriod.map(res1 => {
                if (res1.id == this.billingPeriodId) {
                  this.billingPeriodName = res1.name;
                  this.billingPeriodId = res1.id;
                }
              })
             }, 1000);
             setTimeout(() => {
              this.recurrence.map(res1 => {
                if (res1.id == this.recurrenceId) {
                  this.recurrenceName = res1.name;
                  this.recurrenceId = res1.id;
                }
              })
             }, 1000);
             setTimeout(() => {
              this.applicableDays.map(res1 => {
                if (res1.id == this.applicableDaysId) {
                  this.applicableDaysName = res1.name;
                  this.applicableDaysId = res1.id;
                }
              })
             }, 1000);
            //  this.next1();
             this.next2();
            //  this.next3();
             setTimeout(() => {
              this.getitemCategory();
              this.loader = false;
            }, 2500);
            },            
          err => {
            this.handler.err(err);
            this.loader = false;
          })
         
      }else{
        // this.next1();
        this.next2();
        // this.next3();
        setTimeout(() => {
          this.getitemCategory();
          this.loader = false;
        }, 2500);
      }  
      }

      getImageIcon(id){
        this.service.getAdImage(id).subscribe((res:any)=>{
          this.blob=res;
          this.pic= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
        },
        err=>{
          this.handler.err(err);
     
        })
      }
      
    getDiscount(){
      this.service.getServiceCoupon( this.id).subscribe(res=>{
        this.discountObj = res;
        if (this.discountObj.length > 0) {
          setTimeout(() => {
            this.discountObj.map(res1 => {
              if (res1.id == this.discount ) {
                this.discountName = res1.name;
                this.discountId = res1.id;             
              }
            })
          }, 1000);
        } 
      })
    }

      
    openBottomSheetDiscount(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.discountObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
         this.discountName = res.name;
        this.discountId=res.id;
  
      });
    }

    getCategory(){    
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category=res;        
      })
    }

    checkBox(data){
      data.style="active"
      var x = this.list.filter(res => res.id != data.id);
      x.map(res=>{
        Object.assign(res,{style:"none"})
      })  
    }

    getRecurrence(){
      this.service.getRecurrence().subscribe((res: any) => {
        this.recurrence=res;      
      })
    }



    getitemCategory(){
      this.service.getItemType().subscribe(res=>{
        this.itemCategory = res;
         this.next1();
         })
    }

    openBottomSheetItemCategoryType(dat): void { 
      this.itemCategoryObj=this.itemCategory.filter(res=> res.itemCategory == this.cateId )
       const dialogRef = this.bottomSheet.open(BottomSheet, {
        data:this.itemCategoryObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
       if(res){
        dat.itemTypeName = res.name;
        dat.itemTypeId = res.id;
       }
        });
    }

    getdays(){
      this.service.getApplicableDays().subscribe((res:any)=>{
        this.applicableDays=res;
      }) 
    }

    
    openBottomSheetDays(): void { 
      const dialogRef = this.bottomSheet.open(BottomSheet, {
       data:this.applicableDays,
     });
     dialogRef.afterDismissed().subscribe((res) => {
       this.applicableDaysName = res.name;
       this.applicableDaysId = res.id;
       });
   }

   getBilling(){
     this.service.getBillingPeriod().subscribe((res:any)=>{
       this.billingPeriod=res;
     })
   }

   openBottomSheetBilling(): void { 
    const dialogRef = this.bottomSheet.open(BottomSheet, {
     data:this.billingPeriod,
   });
   dialogRef.afterDismissed().subscribe((res) => {
     this.billingPeriodName = res.name;
     this.billingPeriodId = res.id;
     });
 }
  
    openBottomSheetCategoryType(){
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.cateName = res.name;
          this.cateId = res.id;
          this.getSingleService();
             let x=this.category.find(data=>data.id==res.id);
            let y=this.categorysearchtypes.find(dat=>dat==x);
            if(!y)
            this.categorysearchtypes.push(x)
           
        }
      });
    }

 
    handleFile(files) {
      if (files[0].size < 1048576) {
        this.blob1 = files[0];
        this.pic=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.blob1));
        setTimeout(() => {
          this.captureScreen1();
          this.imageName = this.blob1.name;
        }, 1000);
        this.updateImage = true;
      }
      else {
        this.handler.res('Image Size Should Not Exceeds 1mb ');
      }
  
    }

    captureScreen1(){
      let x = document.getElementById('slideData')
      htmlToImage.toJpeg(x, { quality: 0.20 }).then(dataUrl => {
        fetch(dataUrl).then(res=>res.blob()).then(res1=>this.thumbnail1=res1)
      },err => {
          console.error('oops, something went wrong!', err);
          this.loader=true;
      })
    }

  timePicker(data){
    var x = data.split('T');
    var y = x[1].split('.');
    return y[0]
  }

  createCheck(){
    if(this.name != "" && this.name != null && this.cateId !="" && this.cateId != null && this.htmlContent != "" && this.htmlContent != null&& this.pic != "" && this.pic != null){
        var serviceData;
        var costData;      
        serviceData = this.services.every(res=>res.name && res.inPackCount && res.recurrenceId && res.dayId.length>=1);
        costData =this.pacService.every(res=>res.region && res.cost && res.itemTypeId)     
        if(serviceData && costData){
          this.createSub();
        }else{
          this.handler.res("Please Enter Required Fields");
        }
    }else{
      this.handler.res("Please Enter Required Fields");
    }
  }

  editCheck(){
    if(this.name != "" && this.name != null && this.cateId !="" && this.cateId != null&& this.htmlContent != "" && this.htmlContent != null&& this.pic != "" && this.pic != null){
        var serviceData;
        var costData;     
        serviceData = this.services.every(res=>res.name && res.inPackCount && res.recurrenceId && res.dayId.length>=1);
        costData =this.pacService.every(res=>res.region && res.cost && res.itemTypeId)    
        if(serviceData && costData){
          this.editSubscription();
        }else{
          this.handler.res("Please Enter Required Field");
        }
    }else{
      if(this.name != "" || this.name != null){
        this.handler.res("Please Enter Package Name");
      }
      if(this.cateId !="" || this.cateId != null){
        this.handler.res("Please Select Service Category");
      }
      if(this.htmlContent !="" || this.htmlContent != null){
        this.handler.res("Please Enter Service Detail");
      }
      if(this.htmlContent !="" || this.htmlContent != null){
        this.handler.res("Please Upload Image");
      }
      if(this.name != "" && this.name != null && this.cateId !="" && this.cateId != null && this.htmlContent != "" && this.htmlContent != null&& this.pic != "" && this.pic != null){
      this.handler.res("Please Enter Required Fields");
    }
    }
  }
 
  createSub(){
    let post;
    this.loader = true;
    var packServices=[]  
    this.services.map(res=>{
      packServices.push({
        id:res.id,
        inPackCount:res.inPackCount,
        recurrenceId:res.recurrenceId,
        applicableSunday:res.sunday,
        applicableMonday:res.monday,
        applicableTuesday:res.tuesday,
        applicableWednesday:res.wednesday,
        applicableThursday:res.thursday,
        applicableFriday:res.friday,
        applicableSaturday:res.saturday,
        autoGenerate:res.autoGenerate
      })
    })
    var costItem=[]
    this.pacService.map(res=>{
    costItem.push({
    cost:res.cost,
    region:res.region,
    itemTypeId:res.itemTypeId
  }) 
 })

//  var serviceDetails=[]
//       this.serviceDetails.map(res=>{
//         serviceDetails.push({
//           serviceDetails:res.serviceDetails,
//        }) 
//       })
    if(this.name){
      this.name = this.name.toUpperCase();
    }
   post = {
    "name": this.name,
    "activeInd": true,
    "recurrenceId":this.recurrenceId,
    "orgId":localStorage.getItem('organizationId'),
    // "serviceDetails":serviceDetails,  
    // "img":this.pic,
    "itemCategoryId":this.cateId,
    "applicableDays":this.applicableDaysId,
    "billingPeriod" :this.billingPeriodId,
    "taxIncluded": this.taxIncluded,
    "packageInd": true,
    "discAdId":this.discountId,
    "description":this.htmlContent.replace(/[&]NBSP[;]/gi,""),
     "subCost": costItem,
     "packServices":packServices,
     "dfltCost":this.defcost,
     "address":{
      "houseNbr": this.location.houseNbr,
      "street": this.location.street,
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      "type": 1
       }
      } 
    Object.assign(post,{itemCategoryId:this.cateId})
    Object.assign(post,{itemTypeId:this.itemCateId})  
      this.service.createSubscriptions(post).subscribe((res:any) => {
        this.uploadImage(res.id);
        if(this.src){
          this.provicerServiceId = res.id;
          this.upload();
        }else{
          this.handler.res("Package Created Successfully");
          this.loader = false;
          this.router.navigate(['/manageSubscriptions'])
        }
      
       },
      err => {
        this.loader = false;
        this.handler.err(err);
      }) 
  }

  uploadImage(id) {
    this.loader=true;
    this.service.uploadImageFile(this.blob1,this.imageName,id).subscribe((res:any) => {
      this.handler.res('Image Uploaded Succsessfully!!');
    },err=>{
      this.handler.err(err);
      this.loader = false;
    })
  }

  upload() {
    this.loader=true;
    this.service.uploadVideoFile(this.blob,this.videoName).subscribe((res:any) => {
      this.handler.res('Video Uploaded Succsessfully!!');
      this.uploadDocIcon(res.id)
    },err=>{
      this.handler.err(err);
      this.loader = false;
    })
  }

  
  uploadDocIcon(id){
    this.service.uploadDocIcon(id,this.thumbnail,this.provicerServiceId).subscribe(res=>{
      this.handler.res('Video Icon Updated Succsessfully!!');
      this.loader=false;
      this.router.navigate(['/manageSubscriptions'])
    },err=>{
      this.handler.err(err);
      this.loader = false;
    })
  }


  getVideIcon(id){
    this.check = true;
    this.service.getAdImage(id).subscribe((res:any)=>{
      this.blob=res;
      this.src= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      this.check = false;
    },
    err=>{
      this.handler.err(err);
 
    })
  }


  handleFile1(files) {
    this.videoChange = true;
    this.blob = files[0];
    this.src=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.blob));
    setTimeout(() => {
      this.captureScreen();
      this.videoName = this.blob.name;
    }, 2000);
  }
  
  
  captureScreen(){
    var canvas = document.createElement('canvas');
    canvas.setAttribute('width', '600');
    canvas.setAttribute('height', '360');
    setTimeout(() => {
      var video: any = document.getElementById('vid');
      canvas.getContext('2d').drawImage(video, 0, 0, 600, 360);
      this.thumbnail= fetch(canvas.toDataURL())
      .then(res => res.blob())
      .then(res1 => (this.thumbnail = res1));
 
    })
  }

  editSubscription() {  
    
    this.loader = true;
 if (this.name) {
   this.name = this.name.toUpperCase();
 }
 if (!this.pic) {
   var img = new Image();
   img.src="assets/setting.png"
   var canvas = document.createElement('canvas');
   canvas.width = img.width;
   canvas.height = img.height;
   var ctx = canvas.getContext('2d');
   ctx.drawImage(img, 0, 0);    
   this.pic = canvas.toDataURL('image/jpeg', 1.5);  
 }

  // var serviceDetails=[];
  // this.serviceDetails.map(res=>{
  //   if(res.id){
  //     serviceDetails.push({
  //       id:res.id,
  //       serviceDetails:res.serviceDetails
  //     })
  //   }else{
  //     serviceDetails.push({
  //       serviceDetails:res.serviceDetails
  //     })
  //   } 
  // })
//  this.itemsub.serviceDetails=serviceDetails;
 
 var costItem=[]
    this.pacService.map(res=>{
    costItem.push({
    cost:res.cost,
    region:res.region,
    itemTypeId:res.itemTypeId
  }) 
 })
 this.itemsub.subCost=costItem;

 var packServices=[]  
    this.services.map(res=>{
      packServices.push({
        id:res.id,
        inPackCount:res.inPackCount,
        recurrenceId:res.recurrenceId,
        applicableSunday:res.sunday,
        applicableMonday:res.monday,
        applicableTuesday:res.tuesday,
        applicableWednesday:res.wednesday,
        applicableThursday:res.thursday,
        applicableFriday:res.friday,
        applicableSaturday:res.saturday,
        autoGenerate:res.autoGenerate
      })
    })
this.itemsub.packServices=packServices;
 this.itemsub.name = this.name;
 this.itemsub.activeInd = true;   
 this.itemsub.packageIncludes=this.PackageInclude;
//  this.itemsub.img=this.pic;
 this.itemsub.taxIncluded= this.taxIncluded;
 this.itemsub.recurrenceId = this.recurrenceId;
 this.itemsub.billingPeriod = this.billingPeriodId;
 this.itemsub.applicableDays=this.applicableDaysId;
 this.itemsub.createdBy=localStorage.getItem('currentUserId'),
 this.itemsub.packageInd = true;
 this.itemsub.dfltCost=this.defcost;
 this.itemsub.description=this.htmlContent.replace(/[&]NBSP[;]/gi,""),
 this.itemsub.discAdId = this.discountId,
 this.itemsub.itemCategoryId=this.cateId;
 this.itemsub.itemTypeId=this.itemCateId;
  this.service.updateSubscription(this.id, this.itemsub).subscribe((res:any) => {
    if(this.updateImage){
      this.uploadImage(res.id);
    }
    if(!this.videoChange){
      this.handler.res("Package Updated Successfully");
      this.loader = false;
      this.router.navigate(['/manageSubscriptions']); 
    }else{
      this.provicerServiceId = this.id;
      this.upload();
    }  
 },
   err => {
     this.loader = false;
     this.handler.err(err);

   })
 }

 next(){
   this.pageTwo = true;
   this.pageOne = false;
 }

 
    vendoruser(){
       this.service.getUsersByOrg('SC',this.id,null).subscribe(res => {
        this.users = res;
        this.users= this.users.filter(res =>{return res.reqRoleApproved}) 
      })
    }
 

    onInput() {
      this.location.autoComplete();
    }

  
    add1() {
      var len2 = this.pacService.length;
      if(this.pacService[len2-1].region !="" && this.pacService[len2-1].cost !=""){
        this.pacService[len2-1].icon="clear";
        this.pacService.push({ region: "", icon: 'clear',cost:"",itemTypeId:"",itemTypeName:""});
      }else{
        this.handler.error("Please Enter the Details")
      }
    }

    add2(){  
      var len3 = this.services.length;
  if(this.services[len3-1].name !="" && this.services[len3-1].dayId !="" && this.services[len3-1].inPackCount !=""){
    this.services[len3-1].icon="clear";
    this.services.push({name:"", id: "", icon: 'clear',recurrenceId:"",recurrenceName:"",inPackCount:"",dayName:"",day:this.daysObj,dayId:[],
      monday:false,tuesday:false,wednesday:false,thursday:false,friday:false,saturday:false,sunday:false,autoGenerate:false});
  }else{
    this.handler.error("Please Enter the Details")
  }

    }

    getOrg(){
         this.service.getOrgById(this.id).subscribe((res: any) => {
        this.orgDetail=res.serviceRegions;   
       })
    }


    next1(){
      if (this.pacService.length > 0) {
        this.pacService.map(res => Object.assign(res, { icon: 'clear',itemTypeId:res.itemTypeId }));
        this.pacService.map(dat=>{
          this.itemCategory.map(dat1=>{
            if(dat.itemTypeId == dat1.id){
              Object.assign(dat, { itemTypeName:dat1.name })
            }
          })
        })
      }
      else {
         this.pacService.push({ region: "", icon: 'clear',cost:"",itemTypeId:"",itemTypeName:""});
      }
    }

    getSingleService(){
      this.service.getAllItems().subscribe((res: any) => {
     this.allServices=res;
     this.allServices= this.allServices.filter(res=>{return res.packageInd==false})
    })
 }

//  next3(){
//   if (this.serviceDetails.length > 0) {
//     this.serviceDetails.map(res => Object.assign(res, { icon: 'clear' }))
//   }
//   else {
//      this.serviceDetails.push({ serviceDetails: "", icon: 'clear'});
//   }
// }

// add3() {
//   var len1 = this.serviceDetails.length;
//   if(this.serviceDetails[len1-1].serviceDetails !=""){
//     this.serviceDetails[len1-1].icon="clear";
//     this.serviceDetails.push({ serviceDetails: "", icon: 'clear'});
//   }else{
//     this.handler.error("Please Enter the Details")
//   }
// }

// remove3(i){
//   if(this.serviceDetails.length>1){
//     this.serviceDetails.splice(i, 1); 
//   }else{
//     this.handler.error("Can't Delete")
//   }  
// }

remove1(i){
  if(this.pacService.length>1){
    this.pacService.splice(i, 1); 
  }else{
    this.handler.error("Can't Delete")
  }  
}

remove2(i){
  if(this.services.length>1){
    this.services.splice(i, 1); 
  }else{
    this.handler.error("Can't Delete")
  } 
}

    next2(){
      if (this.services.length > 0) {
        this.services.map(res => Object.assign(res, { icon: 'clear' ,day:this.daysObj,dayId:[]}))
        this.services.map(res=>{
          if(res.applicableSunday){
            res.dayId.push({id:1,name:"Sunday"})
         }
          if(res.applicableMonday){
             res.dayId.push({id:2,name:"Monday"})
          }
          if(res.applicableTuesday){
            res.dayId.push({id:3,name:"Tuesday"})
         }
         if(res.applicableWednesday){
          res.dayId.push({id:4,name:"Wednesday"})
         }
         if(res.applicableThursday){
          res.dayId.push({id:5,name:"Thursday"})
          }
          if(res.applicableFriday){
            res.dayId.push({id:6,name:"Friday"})
            }
         if(res.applicableSaturday){
          res.dayId.push({id:7,name:"Saturday"})
          }
        })
        this.services.map(res=>{
            let y = this.recurrence.find(res1 => res.recurrenceId == res1.id);
            if(y){
              Object.assign(res,{recurrenceName:y.name})
            }
        })
      }
      else {
         this.services.push({name:"",id: "", icon: 'clear',recurrenceId:"",recurrenceName:"",inPackCount:"",dayName:"",day:this.daysObj,dayId:[],
         monday:false,tuesday:false,wednesday:false,thursday:false,friday:false,saturday:false,sunday:false,autoGenerate:false});
      }
    }

    pushDayName(data,i){
      let a=this.services[i].dayId.filter(res=>res.id==data)
      if(a.length>0){
        var b = a[0].id
      }
      if(b==undefined){
        let check=this.services[i].day.find(res=>{return res.id==data})
        if(check){
          this.services[i].dayId.push({id:data,name:check.name})
         if(data=="1"){
          this.services[i].sunday = true
         }
         if(data=="2"){
          this.services[i].monday = true
         }
         if(data=="3"){
          this.services[i].tuesday = true
         }
         if(data=="4"){
          this.services[i].wednesday = true
         }
         if(data=="5"){
          this.services[i].thursday = true
         }
         if(data=="6"){
          this.services[i].friday = true
         }
         if(data=="7"){
          this.services[i].saturday = true
         }
        }
      }else{
        this.handler.res("Day Already Added")
      }
      
    }


    removeChip(i,k) {
      var x = this.services[i].dayId[k].id
      this.services[i].dayId.splice(k, 1);
      if(x=="1"){
        this.services[i].sunday=false;
      }
      if(x=="2"){
        this.services[i].monday=false;
      }
      if(x=="3"){
        this.services[i].tuesday=false;
      }
      if(x=="4"){
        this.services[i].wednesday=false;
      }
      if(x=="5"){
        this.services[i].thursday=false;
      }
      if(x=="6"){
        this.services[i].friday=false;
      }
      if(x=="7"){
        this.services[i].saturday=false;
      }
    }

    openBottomSheetDaySelect(i){
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.daysObj,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          this.pushDayName(res.id,i)
        }
      });
    }

    openBottomSheetCost(data): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.orgDetail,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          this.region=res.region;
          if(this.pacService.length==1){
            data.region =  this.region;
          }else{
            var x=this.pacService.filter(res=>res.region==this.region);
            if(x.length>0){
            var y =x[0].region;
            }
            if(y==undefined){
              data.region = this.region;
            }else{
              this.handler.error("This Pincode is already added.Please Choose Different Pincode");
            }
          }
        }
      });
    }

    openBottomSheetCost1(data): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.orgDetail,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          data.region = res.region;
        }
      });
    }


    openBottomSheetService(dat): void {
      this.allServices = this.allServices.filter(res=>res.itemCategoryId==this.cateId)
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.allServices,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          this.serviceName=res.name;
          this.serviceId=res.id;
          if(this.services.length==1){
            dat.name = this.serviceName;
            dat.id = this.serviceId;
          }else{
            var x = this.services.filter(res=>res.id==this.serviceId);
            if(x.length>0){
              var y =x[0].id;
            }
            if(y==undefined){
              dat.name = this.serviceName;
              dat.id = this.serviceId;
            }else{
              this.handler.error("This service is already added.Please Choose Different service");
            }
          }      
        }
      });
    }

    openBottomSheetRecurrence(data): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.recurrence,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          data.recurrenceId=res.id;
          data.recurrenceName=res.name     
        }
      });
    }


ionViewWillLeave(){
    this.name="";
    this.cateName="";
    this.recurrenceName="";
    this.applicableDaysName="";
    this.billingPeriodName="";
    this.itemCateName="";
    this.PackageInclude="";
    this.pic="";
    this.src = undefined;
    this.src = "";
    this.itemsub = "";
    this.name = ""; 
    this.PackageInclude="";
    this.itemCateId = "";
    this.recurrenceId = "";
    this.billingPeriodId = "";
    this.applicableDaysId="";
    this.cateId="";
    this.pacService = [];
    this.htmlContent=[];
    this.services = [];
    this.list[1].style = 'none';
    this.list[2].style = 'none';
    this.list[3].style = 'none';
    this.list[4].style = 'none';
}


popClose(){
  this.location.pop=false;
  this.location.newSearch="";
  this.location.dummy = false;
}

}

